import { type TestSuite } from 'types/api/test-suites/test-suites'
import {
  type ApiProp,
  testSuitesIdDelete,
  testSuitesIdPatch,
  testSuitesPost
} from 'utils/endpoints-access'

export const TEST_SUITES_CREATE_EDIT_ENDPOINTS = [
  testSuitesPost,
  testSuitesIdPatch,
  testSuitesIdDelete
]

export function getCanCreateAndEditTestSuites(
  getHasAccess: (apiProp: ApiProp) => boolean
) {
  return TEST_SUITES_CREATE_EDIT_ENDPOINTS.every((apiProp) =>
    getHasAccess(apiProp)
  )
}

export function isGremlinOfficialTestSuite(testSuite?: TestSuite) {
  if (!testSuite) {
    return false
  }

  return testSuite?.isOfficial
}

export function sortTestSuitesWithGremlinOfficialAndCurrentlyUsed(
  testSuites: TestSuite[],
  currentTeamId: string
) {
  if (!testSuites) {
    return []
  }

  return [...testSuites].sort((a, b) => {
    if (
      a.targetTeamIds?.includes(currentTeamId) &&
      !isGremlinOfficialTestSuite(b)
    ) {
      return -1
    }

    return 0
  })
}
